import React, { useEffect, useRef } from 'react';
var SnippylyRecorderPlayer = function (props) {
    var recorderId = props.recorderId, onDelete = props.onDelete, showSummary = props.showSummary, summary = props.summary, shadowDom = props.shadowDom, videoEditor = props.videoEditor, playVideoInFullScreen = props.playVideoInFullScreen, retakeOnVideoEditor = props.retakeOnVideoEditor, playbackOnPreviewClick = props.playbackOnPreviewClick;
    var ref = useRef();
    var onDeleteRef = useRef(onDelete);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onDeleteRef.current = onDelete;
    }, [onDelete]);
    useEffect(function () {
        var element;
        var handleOnDelete = function (event) {
            if (onDeleteRef.current) {
                onDeleteRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element === null || element === void 0 ? void 0 : element.addEventListener('onDelete', handleOnDelete);
            }
        }
        return function () {
            if (element) {
                element === null || element === void 0 ? void 0 : element.removeEventListener('onDelete', handleOnDelete);
            }
        };
    }, []);
    return (React.createElement("velt-recorder-player", { ref: ref, "recorder-id": recorderId, "retake-on-video-editor": [true, false].includes(retakeOnVideoEditor) ? (retakeOnVideoEditor ? 'true' : 'false') : undefined, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "show-summary": [true, false].includes(showSummary) ? (showSummary ? 'true' : 'false') : undefined, summary: [true, false].includes(summary) ? (summary ? 'true' : 'false') : undefined, "video-editor": [true, false].includes(videoEditor) ? (videoEditor ? 'true' : 'false') : undefined, "play-video-in-full-screen": [true, false].includes(playVideoInFullScreen) ? (playVideoInFullScreen ? 'true' : 'false') : undefined, "playback-on-preview-click": [true, false].includes(playbackOnPreviewClick) ? (playbackOnPreviewClick ? 'true' : 'false') : undefined }));
};
export default SnippylyRecorderPlayer;
